import React from 'react';
export function Footer() {
  return <footer className="py-12 px-4 border-t border-white/10 bg-black text-center text-gray-500 text-sm font-medium" data-id="element-124">
      <div className="max-w-4xl mx-auto space-y-4" data-id="element-125">
        <p className="text-brand-cream font-black text-base" data-id="element-126">
          Metodo Economia Aziendale Pro™ — Sistema Didattico Integrato
        </p>
        <p className="text-gray-400 font-bold" data-id="element-127">
          Risorse d'eccellenza per la Scuola Secondaria Italiana.
        </p>
        <p data-id="element-128">
          Perché insegnare Economia Aziendale non dovrebbe toglierti i tuoi
          momenti di relax.
        </p>
        <p data-id="element-129">
          <a href="mailto:kitonline27@gmail.com" className="hover:text-brand-orange transition-colors" data-id="element-130">
            📧 kitonline27@gmail.com
          </a>
        </p>
        <p data-id="element-131">
          © Metodo Economia Aziendale Pro™ 2026 — Tutti i diritti riservati.
        </p>
        <p className="text-xs text-gray-600 max-w-2xl mx-auto pt-2" data-id="element-132">
          Materiale didattico conforme alle Indicazioni Nazionali e al Quadro di
          Riferimento del Ministero dell'Istruzione e del Merito (MIM)
          2025/2026.
        </p>
      </div>
    </footer>;
}